import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=36a685b3"
import script from "../script/dashboard.js?vue&type=script&lang=js&external"
export * from "../script/dashboard.js?vue&type=script&lang=js&external"
import style0 from "../less/dashboard.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports